<template>
    <div id="container" class="gdMap"></div>
</template>

<script>
export default {
  props: {
    data:{
        type:Object,
        default:function(){
            return {}
        }
    },
    loading:{
        type:Boolean,
        default:false
    }
  },
  components: {

  },
  data() {
    return {
        resData:this.data,
        time: 1000 * 60 * 30,
        timer: null,
        tableData: [],
        path: [],
        activePath: [],
        pl: [],
        pl1:[],
        activePl: [],
        lat: [],
        activeLat: [],
        latLable: [],
        count:0,
        flag: false,
        key:this.data.mapKey|| 'fdb365f80c74eef59c8f91a1b27376e2',
        map: null,
        center: null,
        infoWindow: null,
        offset: 5,
        perIndex: 0,
        isCity:false,
        loadings:this.loading,
        hasTime:true,
        zoom:4,
        hasLat:true,
        centerLat:[103.397428, 38.90923],
        mapLoad:false,
        styles:{},
        sendCity:true,
        driving:{},
        allPath:[]
    }    
  },
  created(){
    window.loadingMap = this.loadingMap
  },
  mounted() {
    this.loadScript()
  },
  computed: {
    getTime() {
      let len = this.path.length,lens = this.tableData.length
      let start = new Date().getTime();
      if(lens){
        start = this.tableData[lens - 1].AcceptTime.replace(/-/g, "/")
      }
      let init = 1000*3600*20*4,
          startTime = new Date(start).getTime(),
          nowTime = new Date().getTime(),
          tempTime = [new Date().getFullYear(),new Date().getMonth()+1,new Date().getDate()].join('/')+' 23:59:59',
          dayTime = new Date(tempTime).getTime()
      let time = startTime+init;
      if(this.resData.EstimatedDeliveryTime){
        let end = this.resData.EstimatedDeliveryTime.replace(/-/g, "/")
        let endTime = new Date(end).getTime()
        let stateEx = +this.resData.StateEx
        if(endTime<=dayTime||stateEx==202||stateEx==211){
          return '今天'
        }else{
          time = this.resData.EstimatedDeliveryTime.split(" ")[0];
        }
      }
      time = this.$tool.formatDate(time,'MM.dd')+'前'
      return time;
    },
    carDot() {
      let car = null;
      let activeLen = this.path.length
      let isLeft = true;
      if(activeLen>=2){
          let startLng = this.path[activeLen-2].LatAndLng.split(',')[1],
              endLng = this.path[activeLen-1].LatAndLng.split(',')[1];
              isLeft = startLng-endLng<=0
      }
      if (this.per > 0&&!this.state()) {
          let label = this.tableData[0]&&this.tableData[0].Location
          if(this.tableData[1]&&this.tableData[1].Location){
            label = this.tableData[1].Location
          }
          car = {
            lat: this.activePl[this.activePl.length-1],
            label,
            isLeft
          };
        }
      if(!this.sendCity){
        car = {
          lat : this.latLable[this.latLable.length-1].lat,
          label:this.latLable[this.latLable.length-1].label,
          isLeft
        }
      }
      return car;
    },
    per(){
      let per = 0
      if (this.resData.EstimatedDeliveryTime && this.tableData.length) {
        let city = this.tableData[0].Location,
            city1 =this.path.length&&this.path[this.path.length-1].Location
        let len = this.tableData.length,
          end = this.resData.EstimatedDeliveryTime.replace(/-/g, "/"),
          endTime = new Date(end).getTime(),
          start = this.tableData[len - 1].AcceptTime.replace(/-/g, "/"),
          nowTime = new Date().getTime(),
          startTime = new Date(start).getTime()
        let state = +this.resData.State, stateEx = + this.resData.StateEx
        per = (nowTime-startTime) / (endTime-startTime)
        if(!this.state()){
          if(stateEx==211||stateEx==202){
            per = 0.95
            if(stateEx==211){
              per = 0.99
            }
            this.hasTime = true
          }else if(state==4){
            per = 0.9
          }else{
            if(!this.hasTime){
              per = 0.6
            }
          }
          if(city==city1){
            per = 0.9
          }
        }
        if(state===1){
          per=0
        }
        if(per<=0){
          per = 0
        }else if(per>=1){
          per = 0.95
        }
      }
      return per
    }
  },
  watch: {
    data(val){
      this.resData = val
      this.getData()
    },
    loading(val){
        this.loadings = val
    },
    loadings(val){
        this.$emit('update:loading',val)
    }
  },
  methods: {
    loadScript(){
      if(this.key){
        var script = document.createElement("script")
        script.src='https://webapi.amap.com/maps?v=2.0&plugin=AMap.Driving,AMap.MoveAnimation&callback=loadingMap&key='+this.key
        document.body.append(script)
      }
    },
    loadingMap(){
      if(window.AMap){
        var script = document.createElement("script")
        script.src='//webapi.amap.com/ui/1.1/main.js?v=1.1.1'
        document.body.append(script)
        //基本地图加载
        window.map = this.map = new AMap.Map("container", {
            resizeEnable: true,
            center: this.centerLat,//地图中心点
            zoom: this.zoom, //地图显示的缩放级别
        });
        //构造路线导航类
        this.driving = new AMap.Driving({
            map: this.map,
            hideMarkers:true,
            showTraffic:false,
            autoFitView:false
        }); 
        this.mapLoad = true;
        this.getData()
      }
    },
    state(){
      let state = +this.resData.State, stateEx = +this.resData.StateEx;
      if(state==3){
        return true
      }
      return false
    },
    getCity(){
      let state = +this.resData.State, stateEx = +this.resData.StateEx;
      if(stateEx>2&&stateEx!=401){
        return true
      }
      return false
    },
    getData() {
        if(!this.resData.Success||!this.loadingMap){
            return
        }
        let data = this.resData;
        let EstimatedDeliveryTime = data.EstimatedDeliveryTime;
        if(!EstimatedDeliveryTime){
          this.hasTime = false
        }
        this.resData.EstimatedDeliveryTime = this.$tool.formatDate(EstimatedDeliveryTime)
        this.tableData = data.Traces || [];
        this.path = data.PreCoordinates || [];
        this.activePath = data.Coordinates || [];
        let tempArr = data.Coordinates||[]
        tempArr.forEach((ele)=>{
            if(!ele.LatAndLng){
              this.hasLat = false
            }
        })
        if(data.PreCoordinates.length===2&&data.PreCoordinates[0].LatAndLng===data.PreCoordinates[1].LatAndLng){
          this.isCity = true;
        }
        if(this.activePath.length&&!this.getCity()&&this.hasLat&&!this.isCity){
            if(!this.getCity()&&this.activePath.length&&this.path.length){
                let temp = data.PreCoordinates
                this.path = this.activePath
                let end = temp[temp.length-1],
                last = this.path[this.path.length-1]
                if(end.LatAndLng!==last.LatAndLng){
                    this.path.push(end)
                }
            }
        }
        if(data.CityIsNull||data.PreCoordinates.length==0){
          this.sendCity = false
        }
        if(this.getCity()||data.CityIsNull||data.PreCoordinates.length==0){
          if(this.getCity()){
            this.isCity = false;
          }
          this.path = this.activePath
        } 
       if(this.map){
         this.initMap()
       }                    
    },
    initMap() {
      let temp = this.setCenter(this.path)
      this.center = temp;
      this.getLat();
      if(this.path.length>=2&&this.hasLat&&!this.isCity){
        this.getResult();
      }else{
        this.map.setZoomAndCenter(this.zoom,this.center)
        this.onlyCity();
      }
      setTimeout(() => {
          this.loadings = false;
      }, 800);
    },
    onlyCity(){
      if(this.path.length==1||this.isCity){
        this.setDot();
        let sendDot =this.latLable[0]
        if(this.isCity){
          let send = new AMap.Marker({
            position: sendDot.lat,
            content: this.createDom({
              left: "同城件",
              right: sendDot.label,
            }).updateContent5,
            offset: new AMap.Pixel(-125,  -28)
          });
          this.map.add(send)
        }else  if(this.state()){
          let sign = new AMap.Marker({
                position: sendDot.lat,
                content: this.createDom({
                    left: require("@/assets/images/map1.png"),
                    right: {
                      label:sendDot.label,
                      time:this.getSignTime()
                    }
                }).updateContent2,
                offset: new AMap.Pixel(-125, -28)
            });
            this.map.add(sign)
        }else{
          let send = new AMap.Marker({
            position: sendDot.lat,
            content: this.createDom({
              left: "发",
              right: sendDot.label,
            }).updateContent,
            offset: new AMap.Pixel(-125,  -28)
          });
          this.map.add(send)
        }
      }
    },
    setCenter(path){
      let temp =this.centerLat;
      if(path.length&&path[0].LatAndLng){
        let start = path[0].LatAndLng.split(","),end = path[path.length-1].LatAndLng.split(","),
            cutStart = Number(start[0])-Number(end[0]),cutEnd = Number(start[1])-Number(end[1]),
            lat = (cutStart)/2+Number(end[0]),lng = (cutEnd)/2+Number(end[1]);
        this.zoom = 5
        if(Math.abs(cutStart)<=3&&Math.abs(cutEnd)<=5){
          this.zoom = 6
        }
        if(Math.abs(cutStart)<=1&&Math.abs(cutEnd)<=2){
          this.zoom = 7
        }
        if(Math.abs(cutStart)>=8||Math.abs(cutEnd)>=8){
          this.zoom = 5.5
        }
        if(Math.abs(cutStart)>=10||Math.abs(cutEnd)>=10){
          this.zoom = 5
        }
        if(Math.abs(cutStart)>=20||Math.abs(cutEnd)>=30){
            this.zoom = 4.5
        }
        if(Math.abs(cutStart)>=30||Math.abs(cutEnd)>=40){
            this.zoom = 4
        }
        temp = [lng,lat]
      } 
      return temp
    },
    flatArr(arr){
      let path = []
      arr.forEach(ele=>{
        path=path.concat(...ele)
      })
      return path
    },
    draw(form,to,waypoints,callback){
      let opts = [form,to]
      if(waypoints){
        opts = [form,to,waypoints]
      }
      this.driving.search(...opts, (status, result) =>{
          this.driving.clear()
          if (status === 'complete') {
              let {routes=[]} = result
              let {steps=[]} = routes[0]
              let arr = steps.map((ele)=>{
                return ele.path
              })
              let path = this.flatArr(arr)
              if(callback){
                callback(path)
              }
          } else {
              this.count++
              if(this.count==1){
                this.$message.error('路线规划失败')
              }
          }
      });
    },
    carRun(path){
      AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], (PathSimplifier, $)=> {
        if (!PathSimplifier.supportCanvas) {
            this.$message('当前环境不支持 Canvas！');
            return;
        }
        var _this = this
        var emptyLineStyle = {
            lineWidth: 0,
            fillStyle: null,
            strokeStyle: null,
            borderStyle: null
        };
        var pathSimplifierIns = new PathSimplifier({
            zIndex: 100,
            //autoSetFitView:false,
            map:this.map, //所属的地图实例
            getPath: function(pathData, pathIndex) {
                return pathData.path;
            },
            getHoverTitle: function(pathData, pathIndex, pointIndex) {

                return null;
            },
            renderOptions: {
                //将点、线相关的style全部置emptyLineStyle
                pathLineStyle: emptyLineStyle,
                pathLineSelectedStyle: emptyLineStyle,
                pathLineHoverStyle: emptyLineStyle,
                keyPointStyle: emptyLineStyle,
                startPointStyle: emptyLineStyle,
                endPointStyle: emptyLineStyle,
                keyPointHoverStyle: emptyLineStyle,
                keyPointOnSelectedPathLineStyle: emptyLineStyle
            },
            autoSetFitView:false
        });
        window.pathSimplifierIns = pathSimplifierIns;

        pathSimplifierIns.setData([{
            name: '货车',
            path
        }]);

        function onload() {
            pathSimplifierIns.renderLater();
        }

        function onerror(e) {
            _this.$message('图片加载失败！');
        }
        var speed = 15000*parseInt(path.length/100)
        var navg = pathSimplifierIns.createPathNavigator(0, {
            speed,
            pathNavigatorStyle: {
                width: 20,
                height: 46,
                //使用图片
                content: PathSimplifier.Render.Canvas.getImageContent(require('@/assets/images/car3.png'), onload, onerror),
                fillStyle: null,
                zIndex:1000,
                pathLinePassedStyle: {
                    lineWidth: 4,
                    strokeStyle: '#1461E5',
                    strokeOpacity: 1
                }
            }
        });
        navg.start();

    });
    },
    setMarkerDot(){
      this.setDot();
      this.setMaker();
      this.map.setZoomAndCenter(this.zoom,this.center)
    },
    getResult(){
      this.draw(this.lat[0],this.lat[this.lat.length-1],{waypoints:this.lat},(path)=>{
        this.allPath = path
        let color = "#78AAFF"
        if(this.state()){
            color="#1461E5"
        }
        this.setMarkerDot()
        this.polyline(path,color)
      })
      setTimeout(()=>{
        if(!this.state()&&this.resData.State>1){
            if(this.lat.length>2){
              this.draw(this.lat[0],this.lat[this.lat.length-2],null,(path)=>{
                this.polyline(path,"#1461E5")
              })
            }
            this.draw(this.lat[this.lat.length-2],this.lat[this.lat.length-1],null,(path)=>{
              let carPath = [],temp = []
              if(this.sendCity){ //有收寄件城市
                let perIndex = parseInt(this.per*path.length)
                let p = this.per>0.8?0.6:0.1
                let n = parseInt(perIndex*p)
                carPath = carPath.concat(path.slice(n,perIndex))
                temp = temp.concat(path.slice(0,n))
              }else{
                let len = path.length
                carPath = carPath.concat(path.slice(parseInt(len*0.5),len-1))
                temp = temp.concat(path.slice(0,parseInt(len*0.5)))
              }
              this.activePl = carPath;
              this.setMarkerDot()
              this.setCarMaker()
              this.polyline(temp,"#1461E5")
              this.carRun(carPath)
            })
        }
     },400)
    },
    polyline(pl,color) {
      var polyline = new AMap.Polyline({
              map: this.map,
              path:pl,
              strokeColor:color,  // 线颜色
              strokeOpacity: 1,     // 线透明度
              strokeWeight: 4,      // 线宽
              zIndex:99,
            })
      polyline.setMap(this.map)
    },
    getSignTime(){
      let signTime = null,
      year = new Date().getFullYear();
      let time = null;
      if(this.tableData.length){
        signTime = this.tableData[0].AcceptTime.split(' ')[0]
        if(year === +signTime.split('-')[0]){
          time = signTime.split('-')[1]+'月'+signTime.split('-')[2]+'日已签收'
        }else{
          time = signTime.split('-')[0] +'年' + signTime.split('-')[1]+'月'+signTime.split('-')[2]+'日已签收'
        }
      }
      return time
    },
    setMaker() {
      let receiveDot =this.latLable[this.latLable.length-1]|| this.latLable[this.latLable.length - 1],
        sendDot =this.latLable[0] || this.latLable[0],
        signDot = this.latLable[this.latLable.length-1]|| this.latLable[this.latLable.length - 1];
      let time = this.getSignTime()
      if(!this.isCity){
        let send = new AMap.Marker({
          position: sendDot.lat,
          content: this.createDom({
            left: "发",
            right: sendDot.label,
          }).updateContent,
          offset: new AMap.Pixel(-125, -28)
        });
        this.map.add(send)
        if(this.sendCity&&!this.state()){
          let receive = new AMap.Marker({
            position: receiveDot.lat,
            content: this.createDom({
              left: "收",
              right: receiveDot.label,
            }).updateContent,
            offset: new AMap.Pixel(-125, -28)
          });
          this.map.add(receive)
        }else if(!this.sendCity&&!this.state()){
         let isCity = new AMap.Marker({
            position: receiveDot.lat,
            content: this.createDom({
              left: "所在城市",
              right: receiveDot.label,
            }).updateContent6,
            offset: new AMap.Pixel(-125, -28)
          });
          this.map.add(isCity)
        }
      }else{
         let toCity = new AMap.Marker({
            position: sendDot.lat,
            content: this.createDom({
              left: "同城件",
              right: sendDot.label,
            }).updateContent5,
            offset: new AMap.Pixel(-125, -28)
          });
          this.map.add(toCity)
      }
      if(this.state()){
          let sign = new AMap.Marker({
            position: signDot.lat,
            content: this.createDom({
                left: require("@/assets/images/map1.png"),
                right: {
                  label:signDot.label,
                  time
                }
            }).updateContent2,
            offset: new AMap.Pixel(-125, -28)
        });
        this.map.add(sign)
      }
    },
    getLat() {
      this.path.map((ele) => {
        if(ele.LatAndLng){
          let temp = ele.LatAndLng.split(",");
          this.latLable.push({
            lat: new AMap.LngLat(temp[1],temp[0]),
            label: ele.Location,
          });
          this.lat.push(new AMap.LngLat(temp[1],temp[0]));
        }
      });
    },
    setCarMaker() {
      let carDot = this.carDot
      if (carDot && carDot.lat&&!this.state()&&!this.isCity) {
        let car = new AMap.Marker({
            position: carDot.lat,
            zIndex:100,
            content: this.createDom({
          left: this.getTime,
          right: carDot.label,
        }).updateContent1,
            offset: new AMap.Pixel(-125, -28)
        });
        this.map.add(car)
        window.clearMaker = ()=>{
          this.map.remove(car)
        }
      }
    },
    setDot(){
      this.lat.forEach(ele=>{
        var circleMarker = new AMap.CircleMarker({
          center:ele,
          radius:4,
          strokeColor:'#1461E5',
          strokeWeight:2,
          strokeOpacity:1,
          fillColor:'white',
          fillOpacity:1,
          zIndex:10000,
          bubble:true,
          cursor:'pointer',
          clickable: true
        })
        circleMarker.setMap(this.map)
      })
    },
    createDom(content) {
      let display = this.hasTime?'block':'none'
      return {
        updateContent:`<div class="mydom">
                        <div class="map-maker">
                          <div class="left">${content.left}</div>
                          <div class="right">
                            ${content.right}
                          </div>
                        </div>
                      </div>`,
        updateContent1:`<div class="mydom mydom2">
                        <div class="map-maker1" style="display:${display}">
                                <div class="remove-btn" onclick="clearMaker()" ontouchstart="clearMaker()"><i class="el-icon-close"></i></div>
                                <div class="left">预计${content.left}送达</div>
                                <div class="right" style="display:none">当前离开${content.right}</div>
                              </div>
                      </div>`,
        updateContent2:`<div class="mydom">
                              <div class="map-maker map-maker2">
                                <div class="left"><img src="${content.left}"></div>
                                <div class="right">
                                  <p>${content.right.label}<p/>
                                  <p>${content.right.time}<p/>
                                </div>
                              </div>
                         </div>`,
        updateContent3:`<div class="mydom mydom1">
                              <div class="map-maker3"></div>
                         </div>`,   
        updateContent5:`<div class="mydom">
                             <div class="map-maker map-maker5">
                                <div class="left">${content.left}</div>
                                <div class="right">
                                  ${content.right}
                                </div>
                              </div>
                         </div>`,    
        updateContent6:`<div class="mydom">
                             <div class="map-maker map-maker6">
                                <div class="left">${content.left}</div>
                                <div class="right">
                                  ${content.right}
                                </div>
                              </div>
                         </div>`,                                                           
      }
    }
  },
};
</script>

<style lang="scss">
.gdMap{
  .map-maker{
    top:0;
  }
  .map-maker1{
    top:-2px;
  }
  .map-maker2{
    top:-6px;
  }
  .map-maker3{
    top:0;
  }
  .map-maker4{
    top:0;
  }
}
</style>
